/* eslint-disable-next-line  no-unused-vars */
import { createElement, useContext, useRef } from 'react';
import React, { useEffect, useState } from 'react';
import './Drawing.scss';
import { FormControlLabel, Switch, Tooltip } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { MapContext } from '../map/MapContextProvider';
import PolylineOutlinedIcon from '@mui/icons-material/PolylineOutlined';
import PanToolOutlinedIcon from '@mui/icons-material/PanToolOutlined';
import { DrawingService } from '../firebase/DrawingService';
import { CustomDrawingManager, OverlayType } from '../helper/CustomDrawingManager';
let selectedFeatureList = [];
let map2dLayer;
/*global google*/
export default function DrawComponent() {
    const { map, setDrawing2D, setStatus2D, mapWorkspace } = useContext(MapContext);

    const [checked, setChecked] = useState(true);
    const previousValue = useRef();

    const [drawManager, setDrawManager] = useState();
    const [featureCollection, setFeatureCollection] = useState();
    const [selectedFeature, setSelectedFeature] = useState();
    const [editMode, setEditMode] = useState(false);
    const [recordId, setRecordId] = useState();
    const featureCollectionRef = React.useRef(featureCollection);
    const selectedFeatureRef = React.useRef(selectedFeature);
    const recordIdRef = useRef(recordId);
    const menuRef = useRef();
    const drawRef = useRef();
    // const workHelper = new workspaceHelper();

    const drawingService = new DrawingService();

    const drawStyleOpts = {
        strokeColor: '#faca05',
        fillColor: '#fcda50',
        fillOpacity: 0.5,
        visible: true,
        zIndex: 100
    };
    const editStyleOpts = {
        strokeColor: '#007eb6', // blue border when unlocked for editing
        fillColor: '#007eb6',
        draggable: true,
        editable: true,
        fillOpacity: 0.3,
        zIndex: 101
    };

    useEffect(() => {
        map.controls[google.maps.ControlPosition.TOP_CENTER].clear();
        map.controls[google.maps.ControlPosition.TOP_CENTER].push(drawRef.current);
    }, []);

    useEffect(() => {
        if (mapWorkspace) {
            if (Object.prototype.hasOwnProperty.call(mapWorkspace, 'status2D')) {
                if (mapWorkspace.status2D == false) {
                    if (checked) setChecked(false);
                    else stopDrawing();

                    return;
                }
            }

            //trigger loading workspace
            if (checked) startDrawing();
            else setChecked(true);
        }
    }, [mapWorkspace]);

    useEffect(() => {
        selectedFeatureRef.current = selectedFeature;
    }, [selectedFeature]);

    useEffect(() => {
        recordIdRef.current = recordId;
    }, [recordId]);

    useEffect(() => {
        if (map) {
            if (previousValue.current != checked) {
                setStatus2D(checked);
                if (checked == true) {
                    startDrawing();
                } else if (checked == false) {
                    stopDrawing();
                }
            }
            previousValue.current = checked;
        }
    }, [checked, map]);

    useEffect(() => {
        featureCollectionRef.current = featureCollection;
        setDrawing2D(featureCollection);
    }, [featureCollection]);

    const startDrawing = () => {
        console.log('startDrawing');
        if (map) {
            let drawMgr = drawManager;
            if (!drawMgr) {
                drawMgr = new CustomDrawingManager({
                    polygonOptions: drawStyleOpts
                });

                drawMgr.addListener('polygoncomplete', (poly) => {
                    savePoly(poly);
                    drawMgr.setDrawingMode(null);
                });

                map.getDiv().addEventListener('keyup', (evt) => {
                    if (evt.key.toLowerCase() === 'escape') {
                        contextMenuCancel();
                    }
                });

                setDrawManager(drawMgr);
            }

            drawMgr.setMap(map);
            load2DObject();
        }
    };

    const load2DObject = () => {
        if (!mapWorkspace) {
            // let obj = localStorage.getItem('oem_2D_draw');
            // if (obj && obj !== 'undefined') {
            //     obj = JSON.parse(obj);
            //     if (Object.prototype.hasOwnProperty.call(obj, 'features')) {
            //         setFeatureCollection(obj);
            //         loadProjectShapes(obj);
            //         return;
            //     }
            // }

            //todo drawings are saved as geojson ,single object
            // it needs to be saved as WKT
            drawingService.getList().then((objList) => {
                let obj;
                if (objList.length > 0) {
                    obj = objList[objList.length - 1];

                    if (obj.obj) obj = JSON.parse(obj.obj);

                    if (obj && Object.prototype.hasOwnProperty.call(obj, 'features')) {
                        setRecordId(objList[objList.length - 1].recordId);
                        setFeatureCollection(obj);
                        loadProjectShapes(obj);
                        return;
                    }
                }

                obj = {};
                obj.type = 'FeatureCollection';
                obj.features = [];
                setFeatureCollection(obj);
                setRecordId(null);
            });
        } else {
            // workHelper.getItem('drawings2D', (tmp) => {
            let obj = {};

            if (mapWorkspace.list2D) {
                let objList = mapWorkspace.list2D;
                if (objList.length > 0) {
                    obj = objList[objList.length - 1];
                    obj = JSON.parse(obj.obj);
                }
            }

            if (Object.prototype.hasOwnProperty.call(obj, 'features')) {
                setFeatureCollection(obj);
                loadProjectShapes(obj);
            } else {
                let emptyObj = {};
                emptyObj.type = 'FeatureCollection';
                emptyObj.features = [];
                setFeatureCollection(emptyObj);
            }
            // });
        }
    };

    const stopDrawing = () => {
        if (map && drawManager) {
            drawManager.setMap(null);
            // google.maps.event.clearListeners(map, 'contextmenu');
            contextMenuCancel();
            map2dLayer?.forEach((feature) => {
                map.data.remove(feature);
            });
            // newFeatures.forEach(element => {
            //     element.setMap(null);
            // });
            // setNewFeatures([]);
            // setFeatureCollection({});
        }
    };

    // add context menu for events such as delete
    function polyRightClick(evt) {
        const left = evt.domEvent.layerX;
        const top = evt.domEvent.layerY;

        // get the current menu visibility
        const menu = menuRef.current;
        selectedListControl(evt.feature);
        setSelectedFeature(evt.feature);

        // // extract feature properties
        // this.interrogateFeature(evt.feature);

        // this._changeDetectorRef.detectChanges();
        menu.style.display = 'flex';
        menu.style.left = `${left}px`;
        menu.style.top = `${top}px`;

        // this.showMenu(menu, left, top);
    }

    const handleChange = (e) => {
        setChecked(e.target.checked);
    };

    // Load the project shapes e.g. user drawn polygons from the database
    function loadProjectShapes(geojson) {
        selectedFeatureList = [];
        // // TODO: It would be great if there was a way to only reflect changes rather than reloading all shapes
        // //       This would allow us to have multiple polygons in edit mode...
        // if (!this.map) { console.error('System error: invalid google map'); return; }
        // // clear the current geojson

        map2dLayer?.forEach((feature) => {
            map.data.remove(feature);
        });

        // reload geojson

        if (geojson && geojson.features) {
            map2dLayer = map.data.addGeoJson(geojson, {});
            // map.data.setStyle(drawStyleOpts);
            map.data.addListener('contextmenu', (evt) => {
                polyRightClick(evt);
            });
        }
    }

    const hideMenu = () => {
        const menu = menuRef.current;
        if (!menu) {
            console.error('System error: unable to find context menu element;');
            return;
        }
        menu.style.display = 'none';
    };

    const contextMenuCancel = () => {
        if (editMode) {
            selectedListUpdate(selectedFeature);
            map.data.revertStyle(selectedFeature);
            drawManager.setDrawingMode(null);
        }
        hideMenu();
        loadProjectShapes(featureCollection);
    };

    const contextMenuDelete = () => {
        map.data.remove(selectedFeature);
        contextMenuCancel();
        const featureId = selectedFeature.getProperty('id');
        let index = featureCollection.features.findIndex((e) => e.properties.id == featureId);
        if (index != -1) {
            featureCollection.features.splice(index, 1);
            saveLocalStorageAndReload(featureCollection);
        }
    };

    const contextMenuEdit = () => {
        setEditMode(true);
        selectedListUpdate(selectedFeature);

        map.data.overrideStyle(selectedFeature, editStyleOpts);
        hideMenu();
        drawManager.setDrawingMode(null);
    };

    const contextMenuUpdate = () => {
        selectedListUpdate(selectedFeature);
        map.data.revertStyle(selectedFeature);

        const featureId = selectedFeature.getProperty('id');
        const polygon = featureToPolygon(selectedFeature);
        savePoly(polygon, false, featureId);
        hideMenu();
        drawManager.setDrawingMode(null);
    };

    const saveLocalStorageAndReload = (features) => {
        localStorage.setItem('oem_2D_draw', JSON.stringify(features));
        setFeatureCollection({ ...features });
        let data = { obj: JSON.stringify(features) };
        if (recordIdRef.current) {
            //update
            drawingService.updateDocument(data, recordIdRef.current);
        } else {
            drawingService.addDocument(data).then((obj) => {
                setRecordId(obj.recordId);
            });
        }

        loadProjectShapes(features);
    };

    function featureToPolygon(feature) {
        let vertices = [];
        feature.getGeometry().forEachLatLng((latLng) => vertices.push(latLng));
        return new google.maps.Polygon({ ...drawStyleOpts, paths: [vertices] });
    }

    // Save the user drawn polygon

    function savePoly(poly, enableDrawingMode = true, selectedFeatureId) {
        if (enableDrawingMode) poly.setMap(null);

        // setNewFeatures([...newFeaturesRef.current,poly])
        let feature = createPolygonFeature(poly);
        let tmpFeatureCollection = featureCollectionRef.current;

        if (!enableDrawingMode) {
            const featureId = selectedFeatureId;
            let index = featureCollection.features.findIndex((e) => e.properties.id == featureId);
            if (index != -1) {
                tmpFeatureCollection.features[index] = feature;
            }
        } else {
            tmpFeatureCollection.features.push(feature);
        }
        saveLocalStorageAndReload(tmpFeatureCollection);
    }

    const createPolygonFeature = (poly) => {
        const featureId = uuidv4();

        // Convert to geoJson
        const coords = poly
            .getPath()
            .getArray()
            .map((pt) => {
                return [pt.lng(), pt.lat()];
            });
        if (coords.length > 0) {
            coords.push(coords[0]);
        } // add closing point to ensure valid geojson
        const geoFeature = {
            type: 'Feature',
            geometry: {
                type: 'Polygon',
                coordinates: [coords]
            },
            properties: {
                id: featureId,
                stroke: drawStyleOpts.strokeColor,
                fill: drawStyleOpts.fillColor,
                'fill-opacity': drawStyleOpts.fillOpacity,
                zIndex: drawStyleOpts.zIndex
            }
        };
        return geoFeature;
    };

    const selectedListControl = (feature) => {
        let tmpFeature = feature;

        const featureId = tmpFeature.getProperty('id');
        let index = selectedFeatureList.findIndex((e) => e.id == featureId);
        if (index != -1) {
            setEditMode(true);
        } else setEditMode(false);

        return tmpFeature;
    };

    const selectedListUpdate = (feature, mutableState = true) => {
        const featureId = feature.getProperty('id');

        let index = selectedFeatureList.findIndex((e) => e.id == featureId);
        if (index == -1) {
            selectedFeatureList.push({ id: featureId, mutable: mutableState });
        } else {
            selectedFeatureList.splice(index, 1);
        }
    };

    function drawPloygonFunc() {
        drawManager.setDrawingMode(OverlayType.POLYGON);
    }

    function panFunc() {
        drawManager.setDrawingMode(null);
    }

    const rightClickMenu = [
        {
            label: 'Save',
            action: contextMenuUpdate,
            visible: editMode,
            icon: 'Save'
        },
        {
            label: 'Edit',
            action: contextMenuEdit,
            visible: !editMode,
            icon: 'FormatShapes'
        },
        {
            label: 'Delete',
            action: contextMenuDelete,
            icon: 'Delete'
        },
        {
            label: 'Cancel',
            action: contextMenuCancel,
            icon: 'Cancel'
        }
    ];

    return (
        <>
            {/* <RightClickComponent menu={rightClickMenu} menuRef={menuRef} /> */}

            <div className="overlay-draw" ref={drawRef}>
                <div className="draw-toggle">
                    <FormControlLabel
                        control={<Switch checked={checked} onChange={handleChange} />}
                        label={'Edit Mode'}
                    />
                </div>
                {checked && (
                    <div className="drawing-tools">
                        <Tooltip title="Draw Polygon" arrow>
                            <PolylineOutlinedIcon onClick={drawPloygonFunc} />
                        </Tooltip>
                        <Tooltip title="Pan" arrow>
                            <PanToolOutlinedIcon onClick={panFunc} />
                        </Tooltip>
                    </div>
                )}
            </div>
        </>
    );
}
